// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"42584d33","213":"df3bcae2","239":"41fd8ad3","455":"ebe3cb29"}[chunkId] + ".chunk.js";
};